
class AnnouncementBarSlider {
  constructor(element) {
    this.element = element;
    this.track = element.querySelector('.announcement-bar__track');
    this.slides = element.querySelectorAll('.announcement-bar__slide');
    this.slideCount = this.slides.length;
    
    if (this.slideCount > 1) {
      this.init();
    }
  }

  init() {
    this.track.setAttribute('data-slides', this.slideCount);
    
    this.duplicateSlides();
    
    this.setupIntersectionObserver();
  }

  duplicateSlides() {
    this.slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      this.track.appendChild(clone);
    });
  }

  setupIntersectionObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.track.style.animationPlayState = 'running';
        } else {
          this.track.style.animationPlayState = 'paused';
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(this.element);
  }

  setAnimationDuration(duration) {
    this.track.style.animationDuration = `${duration}s`;
  }

  toggleAnimation() {
    const isRunning = this.track.style.animationPlayState !== 'paused';
    this.track.style.animationPlayState = isRunning ? 'paused' : 'running';
    return !isRunning;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const announcementSliders = document.querySelectorAll('.announcement-bar__slider');
  
  announcementSliders.forEach(slider => {
    new AnnouncementBarSlider(slider);
  });
});

window.AnnouncementBarSlider = AnnouncementBarSlider;
